module.exports = __webpack_public_path__ + "static/media/menuPhone.92acc7cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuPhone.svg
// module id = 479
// module chunks = 0